import { Environment, RecordSource, Store } from "relay-runtime";
import type { EnvironmentConfig } from "relay-runtime/lib/store/RelayModernEnvironment";
import type { RecordMap } from "relay-runtime/lib/store/RelayStoreTypes";
import { defaultConfig } from "scmp-sdk/lib/config";

import type { NetworkOptions } from "./network";
import { network } from "./network";

export function createEnvironment(
  networkOptions = {
    authOptions: {
      allowEmptyToken: true,
    },
    urlOptions: {
      headers: {
        apikey: defaultConfig.graphql.apiKey,
      },
      method: "POST",
      url: defaultConfig.graphql.host,
    },
  } as NetworkOptions,
  environmentConfig = {} as Partial<EnvironmentConfig>,
  recordMap?: RecordMap,
) {
  return new Environment({
    ...environmentConfig,
    network: network(networkOptions),
    store: new Store(new RecordSource(recordMap)),
  });
}
